import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation AbsenceReasons($id: Int, $absenceReason: UpdateAbsenceReasonInput!) {
  updateAbsenceReason(id: $id, absenceReason: $absenceReason) {
    id
    message
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

const fieldsName = {
  message: 'T_ABSENCE_REASON_MESSAGE',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function updateAbsenceReason(id, absenceReason) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      absenceReason,
    },
  }).then((data) => data.data.updateAbsenceReason)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default updateAbsenceReason;
